// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedAdvanceFee: Object,
};

const DeleteAdvanceFee = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedAdvanceFee,
  } = props;

  const deleteAdvanceFees = () => {
    submit(selectedAdvanceFee.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteAdvanceFees} type="danger">Delete</SpButton>,
      ]}
      title="Delete Advance Fees"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to delete this advance fees?</div>
        <SpH5 className="pb-3">
          <div>{selectedAdvanceFee.name}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteAdvanceFee;
